export const BRAND = {
  name: "Mumbai Elite Diagnostics",
  tagline: "Advanced Pathology, Cytology, and Clinical Excellence.",
  motto: "Bridging the gap between the microscope and the patient.",
};

export const DOCTOR = {
  name: "Dr. Anubhuti Jain",
  credentials: "MBBS · MD (Pathology) · Gold Medalist",
  role: "Chief Pathologist & Consultant",
  currentPost:
    "Consultant Pathologist, Birla Institute of Medical Science, Gwalior",
  previousPost: "Formerly at Sir H. N. Reliance Foundation Hospital, Mumbai",
  training: "MD (Pathology), Gold Medalist — Gandhi Medical College, Bhopal",
  photo:
    "https://customer-assets.emergentagent.com/job_dr-anubhuti-clinical/artifacts/qsn4i9od_IMG_6699.JPG",
  yearsExperience: "10+",
  papersPublished: "7",
  cases: "9,500+",
  bio: [
    "Dr. Anubhuti Jain is a consultant pathologist currently practicing at the Birla Institute of Medical Science, Gwalior, with a foundation in clinical excellence and a passion for medical education.",
    "Trained at Gandhi Medical College, Bhopal, where she was awarded the Gold Medal for her postgraduate work in Pathology, she has previously served as a consultant at Sir H. N. Reliance Foundation Hospital, Mumbai, and was an International Clinical Observer - Department of Pathology, National University of Singapore (NUS).",
    "She now leads diagnostic reporting, cytology, and teleconsultation at Mumbai Elite Diagnostics, and is a published author focusing on the journey of first-generation medical professionals and a contributor to global medical discourse through research and clinical writing.",
  ],
};

export const WHATSAPP = {
  number: "918871330339",
  message:
    "Hello, I would like to coordinate a diagnostic booking or teleconsultation with Mumbai Elite Diagnostics. Please guide me on the next steps.",
};

// Dedicated teleconsultation / report-review channel (per client's Nov 2026 focus pivot)
export const TELECONSULT = {
  number: "918871330339",
  bookMessage:
    "Hello Dr. Anubhuti, I would like to book an online pathology / lab report teleconsultation.",
  reportReviewMessage:
    "Hello Dr. Anubhuti, I would like a second opinion on my CBC/diagnostic report.",
};

export const whatsappUrl = (customMsg) =>
  `https://wa.me/${WHATSAPP.number}?text=${encodeURIComponent(customMsg || WHATSAPP.message)}`;

export const teleconsultUrl = (customMsg) =>
  `https://wa.me/${TELECONSULT.number}?text=${encodeURIComponent(customMsg || TELECONSULT.bookMessage)}`;

export const CONTACT = {
  email: "care@mumbaielitediagnostics.com",
  phone: "+91 88713 30339",
  address: {
    line1: "Main Fort Road",
    line2: "Vinay Nagar Sector 3",
    city: "Gwalior, Madhya Pradesh, India",
  },
  hours: [
    { label: "Mon — Sat", time: "8:00 AM — 10:00 PM" },
    { label: "Sunday", time: "8:00 AM — 5:00 PM" },
  ],
  appointmentNote: "Appointment basis only",
  socials: [
    { label: "Instagram", url: "https://www.instagram.com/drcellwhisperer" },
    { label: "Practice Site", url: "https://sites.google.com/view/dranubhutijain/home" },
    { label: "LinkedIn", url: "https://www.linkedin.com/" },
    { label: "ResearchGate", url: "https://www.researchgate.net/" },
    { label: "PubMed", url: "https://pubmed.ncbi.nlm.nih.gov/" },
  ],
};

export const SERVICES = [
  {
    number: "A",
    slug: "pathology",
    title: "Pathology & Advanced Lab Testing",
    short: "Routine and specialised biochemistry, haematology, and clinical pathology.",
    long: "Routine and specialised biochemistry, haematology, and clinical pathology utilising cutting-edge diagnostic frameworks. Comprehensive panels reviewed personally by a Gold Medalist consultant.",
    highlights: [
      "Full biochemistry & haematology panels",
      "Autoimmune, endocrine, and tumour markers",
      "Rapid turnaround with consultant sign-off",
    ],
  },
  {
    number: "B",
    slug: "cytology",
    title: "Cytology",
    short: "Fluid analysis, exfoliative cytology, and precise cell-structure interpretation.",
    long: "Specialised fluid analysis, exfoliative cytology, and precise cell-structure interpretation. Liquid-based and conventional smears reviewed against international reporting standards.",
    highlights: [
      "Liquid-based & conventional cytology",
      "Body fluid & effusion analysis",
      "Bethesda-standard cervical screening",
    ],
  },
  {
    number: "C",
    slug: "fnac",
    title: "FNAC (Fine Needle Aspiration Cytology)",
    path: "/services/fnac-test-gwalior",
    short: "Rapid, minimally invasive diagnostics for lumps, swellings, and tumours.",
    long: "Rapid, minimally invasive diagnostic technique for lumps, swellings, and tumour configurations with gold-standard reporting. Same-day preliminary readings on most cases.",
    highlights: [
      "USG-guided & palpation-guided FNAC",
      "On-site rapid staining",
      "Detailed cytomorphological correlation",
    ],
  },
  {
    number: "D",
    slug: "opd",
    title: "OPD (Outpatient Department)",
    short: "Clinical consultations, patient counseling, and preventive wellness assessments.",
    long: "Dedicated clinical consultations, patient counselling, and preventive wellness assessments. In-person and secure video teleconsultation available.",
    highlights: [
      "Report interpretation & second opinions",
      "Preventive health check-ups",
      "Video teleconsultation (secure)",
    ],
  },
];

export const B2B_OPTIONS = [
  {
    title: "Sample Outsourcing",
    body: "Outsource complex histopathology and cytology reporting to a Gold Medalist pathologist. Ideal for local clinics, small nursing homes, and standalone collection centres.",
  },
  {
    title: "Corporate Wellness",
    body: "Annual employee health checks, executive medicals, and on-site sample collection for HR-led wellness programmes.",
  },
  {
    title: "Lab Consulting",
    body: "Laboratory audits, protocol design, staff training, and NABL / ISO readiness support for growing diagnostic labs.",
  },
];

export const SERVICE_NEEDED_OPTIONS = [
  "Sample Outsourcing",
  "Corporate Wellness",
  "Lab Consulting",
];
